export const BRAND_COOKIE = 'vi-brand'
export const COUNTRY_COOKIE = 'vi-country'
export const CART_HANDOFF_COOKIE = 'vi-cart-handoff'
export const CHECKOUT_MARKET_MOVE_COOKIE = 'vi-checkout-market-move'
export const LEGACY_PENDING_COUNTRY_COOKIE = 'vi-country-pending'

export const MARKET_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365
export const HANDOFF_COOKIE_MAX_AGE_SECONDS = 60 * 5
export const CHECKOUT_MARKET_MOVE_COOKIE_MAX_AGE_SECONDS = 60

export function getMarketCookieOptions(maxAge: number) {
  return {
    path: '/',
    sameSite: 'lax' as const,
    secure: process.env.NODE_ENV === 'production',
    maxAge,
  }
}
